import React from 'react';
import ClientsEiacLayout from './clients-eiac-layout';

export default class ClientsEiac extends React.Component<{}, {}> {
    render() {
        return (
            <ClientsEiacLayout />
        )
    }
}